import { StatusBar } from "expo-status-bar";
import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  Alert,
  Animated,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Tag from "app/components/chapter/Tag";
import ValueListItem from "app/components/ValueListItem";
import MomentBullet from "app/components/chapter/MomentBullet";
import Timeline from "app/components/Timeline";
import valueActions from "app/utils/valueActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import draggableHelpers from "app/utils/draggableHelpers";
import * as RootNavigation from "app/utils/RootNavigation.js";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";

import Icon from "app/components/Icon";
import HoverableTooltip from "app/components/HoverableTooltip";
import Badge from "app/components/chapter/Badge";

import Hoverable from "app/components/Hoverable";
import { Ionicons } from "@expo/vector-icons";
import Draggable from "app/components/Draggable";
import MomentComposer from "app/components/chapter/MomentComposer";

import store from "app/redux/store";

import RecursiveGeneration from "app/components/RecursiveGeneration";

import { StyleContext } from "app/contexts/Style";

// const autoExpandFirstGen = false;
const autoExpandFirstGen = true;

export default class Generation extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    ids: PropTypes.array,
    level: PropTypes.number,
    name: PropTypes.string,
    // navigation: PropTypes.object,
    // value
    // genKey = ['parents', 'children']
    // level = [1, -1]
    // nextGen // used just to rerender when props update
    // listView: PropTypes.bool,
  };

  static defaultProps = {
    scaleFactor: 0.2,
    depthCutoff: 4,
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded || false,
      expandedIds:
        autoExpandFirstGen && (props.level == 1 || props.level == -1)
          ? props.ids
          : [],
      values: [],
      // loading: true,

      draggingValue: null,
      // flexingLevelKeys: 0,
      hoverInKeys: [],
      hoverOutKeys: [],
      flexAnim: new Animated.Value(1),
      flexAnims: [],
      childSizes: {},
      expandedTrees: [],
      expandAllTrees: false,
      showMore: false,
      loadingGrandGen: true,

      showComposer: false,
      query: "",
      showArchived: false,
    };
    this.flexingLevels = 0;
  }

  setValues = () => {
    let { ids, includeNotes, name } = this.props;
    let { values } = store.getState();
    let genValues = [];
    if (!ids?.length && ids?.length !== 0) {
      console.log("No IDS", this.props.value, this.props.ids);
    } else {
      if (this.props.value.is_note && ids?.length === 0 && name == "parents") {
        genValues = [valueHelpers.journalValue];
      } else {
        genValues = values.filter((v) => ids.includes(v.id));
        if (name == "parents") {
          // if (this.props.level == 1) console.error(genValues);
          // genValues = genValues.filter(
          //   (v) => !v.completed_at && !v.archived_at
          // );
          // if (this.props.level == 1) console.error("after filter", genValues);
          genValues = valueHelpers.filterToCurrentRevisions(genValues, values);
        }
        genValues = textHelpers.sortByIds(ids, genValues);
      }
    }
    // if (!includeNotes) {
    //   let nonNoteGenValues = genValues.filter((v) => !v.is_note);
    //   if (!!nonNoteGenValues.length) {
    //     if (nonNoteGenValues.length < genValues.length) {
    //       this.props.setHasNotes && this.props.setHasNotes(true);
    //     }
    //     genValues = nonNoteGenValues;
    //   } else {
    //     this.props.setShowNotes && this.props.setShowNotes(true);
    //   }
    // }
    this.setState({ values: genValues });
  };

  componentDidMount = async () => {
    this.setValues();
    this.subscribe();
    this.fetchGrandGeneration();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.includeNotes != this.props.includeNotes) {
      this.setValues();
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe = async () => {
    this.unsubscribe = store.subscribe(async () => {
      this.setValues();
    });
  };

  fetchGrandGeneration = async () => {
    // this fetches the next grand-generation
    // triggered when dots are expanded
    // the dots are already fetched from the parent
    // and this pre-loads the next level, to be ready for an instant expansion
    let { value, ids, name } = this.props;
    let res;
    if (name == "parents") res = await valueActions.getGrandParents(ids);
    else res = await valueActions.getGrandChildren(ids);
    console.log("grand gen res:", value, res);
    if (res?.success) this.setState({ loadingGrandGen: false });
    else this.setState({ loadingGrandGen: false, error: true });
  };

  render() {
    let { name, level, loading, color, button } = this.props;
    let { expanded, expandedIds, values, loadingGrandGen, showArchived } = this.state;
    if (loading) {
      return <ActivityIndicator color={color} />;
      // } else if (!expanded && !expandedIds.length) {
      // return this.renderDots(values);
    } else {
      // return (
      //   <View style={{ flexDirection: "row" }}>
      //     {values.map((value, i) => (
      //       <View key={`${i}-${value.id}`}>
      //         {name == "children" && <Value value={value} momentRing />}
      //         <RecursiveGeneration
      //           value={value}
      //           ids={name == "parents" ? value.parent_ids : value.child_ids}
      //           name={name}
      //           level={level + 1}
      //         />
      //         {name == "parents" && <Value value={value} momentRing />}
      //       </View>
      //     ))}
      //   </View>
      // );

      // let size = 100 - Math.abs(level) * 10;
      // let sizeChangeFactor = name == "parents" ? 15 : 10;
      let sizeChangeFactor = 10;
      // let size = 100 + sizeChangeFactor + level * sizeChangeFactor;
      let size = 100 + level * sizeChangeFactor;
      size = Math.max(size, 50);
      // size = Math.min(size, 200);

      return (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            flex: 1,
            alignItems: name == "parents" ? "flex-end" : "flex-start",
            marginBottom: this.context.sizes.base,
          }}
        >
          {!!button && (
            <View
              style={{
                alignSelf: "stretch",
                maxHeight: 100,
                minWidth: 100,
                justifyContent: "center",
              }}
            >
              <View style={{ flexDirection: "row", alignSelf: "center" }}>
                {button}
              </View>
            </View>
          )}

          {!!this.props.collapseLevel && (
            <Badge
              mobileLarge
              moment={{
                value: {
                  icon: "x",
                  text: "Collapse",
                },
              }}
              onPress={this.props.collapseLevel}
            />
          )}

          {values.map((value, i) => {
            if (!expandedIds.includes(value.id))
              return (
                <View key={`${i}-${value.id}`}>
                  <Badge
                    mobileLarge
                    moment={{ value }}
                    onPress={() =>
                      this.setState({ expandedIds: [...expandedIds, value.id] })
                    }
                  />
                </View>
              );
            else {
              let valColor = valueHelpers.getColor(value);
              return (
                <Hoverable key={`${i}-${value.id}`}>
                  {(isHovered) => {
                    let appliedsize = size;
                    // if (isHovered) appliedsize = Math.max(size, 100);
                    return (
                      <View
                        key={`${i}-${value.id}`}
                        style={
                          {
                            // flexShrink: 1,
                            // borderWidth: 1,
                            // borderColor: isHovered ? "red" : "white",
                          }
                        }
                      >
                        {name == "children" && (
                          <Tag
                            icon
                            value={value}
                            momentRing
                            size={appliedsize}
                            relationship={{
                              type: "child",
                              id: this.props.value.id,
                            }}
                            // momentBulletOnPress
                            onPress={(e) =>
                              RootNavigation.push(
                                "Project",
                                { id: value.id },
                                e,
                              )
                            }
                          />
                        )}
                        <View
                          style={{
                            zIndex: name == "parents" ? level : 0,
                          }}
                        >
                          <RecursiveGeneration
                            value={value}
                            ids={
                              name == "parents"
                                ? value.parent_ids
                                : value.child_ids
                            }
                            name={name}
                            level={name == "parents" ? level + 1 : level - 1}
                            loading={loadingGrandGen}
                            color={valColor}
                            collapseLevel={() => {
                              let newExpandedIds = expandedIds;
                              newExpandedIds.splice(
                                expandedIds.indexOf(value.id),
                                1,
                              );
                              this.setState({ expandedIds: newExpandedIds });
                            }}
                          />
                        </View>
                        {name == "parents" && (
                          <Tag
                            icon
                            value={value}
                            momentRing
                            size={appliedsize}
                            relationship={{
                              type: "parent",
                              id: this.props.value.id,
                            }}
                            // momentBulletOnPress
                            onPress={(e) =>
                              RootNavigation.push(
                                "Project",
                                { id: value.id },
                                e,
                              )
                            }
                          />
                        )}
                      </View>
                    );
                  }}
                </Hoverable>
              );
            }
          })}
          {this.renderArchived(size)}
          {this.renderComposer(size)}
        </View>
      );
    }
  }

  renderArchived = (size) => {
    let { value, name, level } = this.props;
    let { showArchived } = this.state;
    if (Math.abs(level) !== 1) return null;
    const archivedEntries =
      name == "parents"
        ? value?.archived_parent_ids || []
        : value?.archived_child_ids || [];
    if (!archivedEntries.length) return null;
    const { values } = store.getState();
    const archivedValues = archivedEntries
      .map((entry) => values.find((v) => v.id == entry.id))
      .filter(Boolean);
    return (
      <View style={{ alignItems: "center" }}>
        <TouchableOpacity
          onPress={() => this.setState({ showArchived: !showArchived })}
        >
          <View style={{ flexDirection: "row", opacity: 0.5 }}>
            <Text>{showArchived ? "Hide archived" : "Show archived"}</Text>
          </View>
        </TouchableOpacity>
        {showArchived &&
          archivedValues.map((archivedValue, i) => (
            <View key={`archived-${i}-${archivedValue.id}`} style={{ opacity: 0.4 }}>
              <Tag
                icon
                value={archivedValue}
                momentRing
                size={size}
                onPress={(e) =>
                  RootNavigation.push("Project", { id: archivedValue.id }, e)
                }
              />
            </View>
          ))}
      </View>
    );
  };

  renderComposer = (size) => {
    let { value, name, level } = this.props;
    let { showComposer, query } = this.state;
    return (
      <View
        style={{
          // alignSelf: "stretch",
          // maxHeight: 100,
          justifyContent: "center",
        }}
      >
        <View style={{ flexDirection: "row", alignSelf: "center" }}>
          {showComposer && (
            <View style={{ width: 200 }}>
              <MomentComposer
                parentId={value.id}
                parentIsValue
                parentIsChild={name == "parents"}
                placeholder={`Find or create ${textHelpers.singular(name)}`}
              />
            </View>
          )}
          {/*autoExpandFirstGen && Math.abs(level) == 1 && !showComposer ? (
            <HoverableTooltip
              rightInline
              text={`Add ${textHelpers.singular(name)}`}
            >
              <Value
                backgroundStyle={{
                  borderWidth: 2,
                  borderColor: this.context.colors.fill,
                }}
                value={{
                  text: "+",
                  color: this.context.colors.empty,
                }}
                size={size}
                onPress={() => {
                  if (showComposer)
                    this.setState({ showComposer: false, query: "" });
                  else this.setState({ showComposer: true });
                }}
                </HoverableTooltip>
            */}
          {autoExpandFirstGen && Math.abs(level) == 1 && !showComposer ? (
            <Badge
              mobileLarge
              moment={{
                value: {
                  icon: showComposer ? "x" : "plus",
                  text: showComposer
                    ? "cancel"
                    : `Add ${textHelpers.singular(name)}`,
                },
              }}
              onPress={() => {
                if (showComposer)
                  this.setState({ showComposer: false, query: "" });
                else this.setState({ showComposer: true });
              }}
            />
          ) : (
            <Badge
              mobileLarge
              moment={{
                value: {
                  icon: showComposer ? "x" : "plus",
                  text: showComposer
                    ? "cancel"
                    : `Add ${textHelpers.singular(name)}`,
                },
              }}
              onPress={() => {
                if (showComposer)
                  this.setState({ showComposer: false, query: "" });
                else this.setState({ showComposer: true });
              }}
            />
          )}
        </View>
      </View>
    );
  };

  handleHoverIn = async (key, childCount) => {
    if (this.state.updatingHoverOutKeys) {
      console.log("delaying hover in");
      await new Promise((resolve) => setTimeout(resolve, 100));
      this.handleHoverIn(key, childCount);
      return;
    }
    let hoverOutKeys = this.state.hoverOutKeys.filter((k) => k != key);
    let hoverInKeys = this.state.hoverInKeys;
    if (!hoverInKeys.includes(key)) {
      hoverInKeys.push(key);
    }
    this.setState({ hoverOutKeys, hoverInKeys });
    let hoveredKeys = hoverInKeys.filter((k) => !hoverOutKeys.includes(k));
    // console.log("hover in", hoveredKeys.length);
    // Animated.timing(this.state.flexAnim, {
    //   toValue: hoveredKeys.length,
    //   duration: 400,
    // }).start()

    if (!this.state.flexAnims.find((f) => f.key == key)) {
      let flexAnims = this.state.flexAnims;
      flexAnims.push({
        key,
        childCount,
        flex: new Animated.Value(1),
        minWidth: new Animated.Value(0),
      });
      await this.setState({ flexAnims });
    }
    this.state.flexAnims.forEach((fa) => {
      if (hoverInKeys.includes(fa.key)) {
        let depthFactor = 1.3 ** hoveredKeys.length;
        let toValue = fa.childCount + depthFactor;
        Animated.timing(fa.flex, {
          toValue,
          duration: 300,
          useNativeDriver: !ENV.WEB,
        }).start();
        Animated.timing(fa.minWidth, {
          toValue: 100 * childCount,
          duration: 300,
          useNativeDriver: !ENV.WEB,
        }).start();
      }
    });
  };

  handleHoverOut = async (key, childCount) => {
    // await new Promise((resolve) => setTimeout(resolve, 300));
    await this.setState({ updatingHoverOutKeys: true });
    let instances = 0;
    this.state.hoverInKeys.forEach((k) => {
      if (k == key) instances++;
    });
    let hoverInKeys = this.state.hoverInKeys.filter((k) => k != key);
    // if(instances > 1){
    //   // this means we re-hovered during the timeout
    //   hoverInKeys.push(key) // keep one instance
    //   this.setState({hoverInKeys})
    //   return
    // }

    let hoverOutKeys = this.state.hoverOutKeys;
    if (!hoverOutKeys.includes(key)) {
      hoverOutKeys.push(key);
    }
    await this.setState({ hoverOutKeys, hoverInKeys });
    await this.setState({ updatingHoverOutKeys: false });

    let hoveredKeys = hoverInKeys.filter((k) => !hoverOutKeys.includes(k));
    // console.log("hover out", hoveredKeys.length, key);

    let flexAnim = this.state.flexAnims.find((f) => f.key == key);
    if (!flexAnim) {
      let flexAnims = this.state.flexAnims;
      flexAnims.push({
        key,
        childCount,
        flex: new Animated.Value(1),
        minWidth: new Animated.Value(0),
      });
      await this.setState({ flexAnims });
    }
    // this.state.flexAnims.forEach(fa => {
    else {
      // console.log("flex to 1");
      // let depthFactor = 1.3**hoveredKeys.length
      // let toValue = Math.max(1, depthFactor) //+ childCount
      // console.log(flexAnim.flex._value);
      Animated.timing(flexAnim.flex, {
        toValue: 1,
        duration: 300,
        useNativeDriver: !ENV.WEB,
      }).start(() => {
        // console.log("flex done:", flexAnim.flex._value);
      });
      Animated.timing(flexAnim.minWidth, {
        toValue: 0,
        duration: 300,
        useNativeDriver: !ENV.WEB,
      }).start();
    }
  };

  renderDots = (values) => {
    let { expandedIds } = this.state;
    return (
      <View style={[styles.contentRow, { justifyContent: "flex-end" }]}>
        <TouchableOpacity
          onPress={() => {
            this.setState({ expanded: true });
          }}
        >
          <View style={{ flexDirection: "row" }}>
            {values.map((value, i) => {
              return (
                <Badge
                  mobileLarge
                  key={i}
                  moment={{ value }}
                  onPress={() =>
                    this.setState({ expandedIds: [...expandedIds, value.id] })
                  }
                />
              );
              let valColor = valueHelpers.getColor(value);
              let { color, opacity } = valueHelpers.iconColor(value, valColor);
              return (
                <View
                  key={`${i}-${value.id}-dot`}
                  style={[styles.dot, { backgroundColor: valColor }]}
                >
                  <View
                    style={{
                      ...StyleSheet.absoluteFillObject,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      name={valueHelpers.getIcon(value)}
                      color={color}
                      opacity={opacity}
                      size={sizes.base}
                    />
                  </View>
                </View>
              );
            })}
          </View>
        </TouchableOpacity>
      </View>
    );
  };

  // renderGeneration = ({ values }) => {
  //   let { key, level } = this.props;
  //   let { expanded } = this.state;
  //   let {
  //     draggingValue,
  //     hoverInKeys,
  //     hoverOutKeys,
  //     flexAnims,
  //     expandedTrees,
  //     expandAllTrees,
  //     showMore,
  //   } = this.state;

  //   // let scale = 1.0 + level * 0.15;
  //   let scale = 1.0;
  //   let levelScale = scale;

  //   let rootSize = 100;
  //   let size = rootSize;

  //   if (!expanded) {
  //     return this.renderDots(values);
  //   } else {
  //     return (
  //       <View style={{ flexDirection: "row" }}>
  //         {values.map((value, i) => (
  //           <View key={i}>
  //             <RecursiveGeneration value={value} key={key} level={level + 1} />
  //             <Value key={`${i}-${value.id}`} value={value} />
  //           </View>
  //         ))}
  //       </View>
  //     );
  //   }

  //   let hoveredKeys = hoverInKeys.filter((k) => !hoverOutKeys.includes(k));
  //   let flexMultiplier = hoveredKeys.length;

  //   // let nextGen = initialNextGen || value[key] || []
  //   let nextGen =
  //     initialNextGen ||
  //     (key == "parents"
  //       ? valueHelpers.getParents({ value, filterToActive: true })
  //       : valueHelpers.getChildren({ value, sort: true })) ||
  //     [];
  //   // nextGen = textHelpers.oldestFirst(nextGen, 'completed_at', 'created_at')

  //   // hide completed items if value is infinite
  //   let allowShowMore = false;
  //   if (
  //     !showMore &&
  //     (valueHelpers.isInfinite(value) || valueHelpers.isProject(value))
  //   ) {
  //     nextGen = nextGen.filter((v) => {
  //       if (!!v.completed_at) {
  //         allowShowMore = true;
  //         return false;
  //       }
  //       return true;
  //     });
  //   }

  //   let zIndex = -1;
  //   let backgroundColor = "transparent";
  //   if (!!draggingValue) {
  //     zIndex = 99;
  //   }
  //   let borderRadius = 0;
  //   // if(this.state.hoveredValue?.id == value.id){
  //   //   zIndex = 99
  //   //   backgroundColor = colors.fill
  //   //   borderRadius = 10
  //   // }

  //   let reverse = key == "parents";
  //   let nextLevel = key == "children" ? level - 1 : level + 1;
  //   // let nextLevel = (level - 1)
  //   let opacity = 1.0 - level * 0.2;
  //   let uKey = `${value.id}-${level}-${key}`;

  //   let flexAnim = flexAnims.find((f) => f.key == uKey);
  //   if (!!nextGenOnly) flexAnim = { flex: 1 };
  //   // flexAnim = null

  //   // let childSize = size

  //   return (
  //     <Hoverable
  //       key={uKey}
  //       onHoverIn={() => {
  //         this.handleHoverIn(uKey, nextGen.length);
  //         this.props.hoverIn && this.props.hoverIn(value);
  //       }}
  //       onHoverOut={async () => {
  //         this.handleHoverOut(uKey, nextGen.length);
  //         this.props.hoverOut && this.props.hoverOut(value);
  //       }}
  //     >
  //       {(isHovered) => {
  //         // if(!!draggingValue) isHovered = false
  //         // isHovered = false

  //         let flexExpansion = isHovered;
  //         if (level > 0) flexExpansion = false;

  //         //else if(!nextGen?.length) flexExpansion = false
  //         //flexExpansion = false
  //         return (
  //           <Animated.View
  //             key={`${value.id}-${level}-${key}`}
  //             style={[
  //               // level == 0 && { borderWidth: 5, flex: 1 },
  //               styles.col,
  //               // {maxWidth: 300},
  //               {
  //                 // paddingTop: sizes.base * scale,
  //                 zIndex,
  //                 // backgroundColor,
  //                 // borderRadius,
  //                 transform: [
  //                   // {translateX: 100} // wtf was this supposed to do?
  //                 ],
  //                 // borderWidth: 1, borderColor: 'red',
  //               },
  //               // (flexExpansion && !draggingValue && !this.props.draggingValue?.id) && {
  //               flexExpansion &&
  //                 !draggingValue && {
  //                   zIndex: 99,
  //                   // backgroundColor: colorHelpers.hexToRgbaString(colors.foreground, 0.1),
  //                   // backgroundColor: colorHelpers.hexToRgbaString(colors.trim, 0.4),
  //                   backgroundColor: colorHelpers.hexToRgbaString(
  //                     colors.empty,
  //                     0.5
  //                   ),
  //                   borderRadius: 10,
  //                   // flex: 3 + flexMultiplier,
  //                   // flex: 2 + Math.max(0, nextGen.length-2),
  //                   minWidth: 100 * nextGen.length,
  //                   // minWidth: flexAnim?.minWidth,
  //                   // borderWidth: 1,
  //                 },
  //               // { flex: flexAnim },
  //               // !!flexAnim && !this.props.draggingValue?.id && {
  //               !!flexAnim && {
  //                 flex: flexAnim.flex,
  //               },
  //               listView && { paddingLeft: sizes.small },
  //               reverse ? styles.colReverse : null,
  //               (this.props.wrap || listView) && styles.colWrap,
  //               // !!level && isHovered && { borderColor: colors.fill, borderWidth: 2 },
  //               !!level &&
  //                 isHovered && {
  //                   backgroundColor: colorHelpers.hexToRgbaString(
  //                     colors.fill,
  //                     0.1
  //                   ),
  //                 },
  //               !visible && { opacity: 0.5 },
  //               style,
  //             ]}
  //             ref={(ref) => {
  //               this[uKey] = ref;
  //             }}
  //             onLayout={({ nativeEvent }) => {
  //               if (this[uKey]) {
  //                 this[uKey].measure((x, y, width, height, pageX, pageY) => {
  //                   if (nextGen.length > 1) {
  //                     let childSize = width / (nextGen.length - 1);
  //                     childSize = Math.min(size, childSize);
  //                     let newChildSizes = this.state.childSizes;
  //                     // newChildSizes[uKey] = childSize
  //                     // this.setState({childSizes: newChildSizes})
  //                   }
  //                 });
  //               }
  //             }}
  //           >
  //             {!nextGenOnly && (
  //               <Draggable
  //                 onDragStart={() => {
  //                   this.setState({ draggingValue: value });
  //                   this.props.onDragStart && this.props.onDragStart(value);
  //                 }}
  //                 onDragMove={(coords) =>
  //                   this.props.onDragMove && this.props.onDragMove(coords)
  //                 }
  //                 onDragEnd={(coords) => {
  //                   this.setState({ draggingValue: null });
  //                   this.props.onDragEnd && this.props.onDragEnd(coords);
  //                 }}
  //                 freezeOnRelease={this.props.freezeOnRelease}
  //                 shelfThreshold={this.props.shelfThreshold}
  //                 onShelf={() =>
  //                   this.props.onShelf && this.props.onShelf(value)
  //                 }
  //                 onToss={
  //                   !!this.props.onToss ? () => this.props.onToss(value) : null
  //                 }
  //                 flex={listView}
  //               >
  //                 {(isDragging) => {
  //                   let textIcon =
  //                     value.id == this.props.draggingValue?.id &&
  //                     draggableHelpers.determineTextIcon(
  //                       value,
  //                       this.props.overlappedValue
  //                     );
  //                   let scale = undefined;
  //                   // if(!!textIcon) size *= 0.66
  //                   // else if(this.props.overlappedValue?.id == value.id) size *= 1.1
  //                   if (!!textIcon) scale = 0.66;
  //                   else if (this.props.overlappedValue?.id == value.id)
  //                     scale = 1.1;
  //                   if (listView) {
  //                     scale = 0.5;
  //                     return (
  //                       <ValueListItem
  //                         value={value}
  //                         scale={scale}
  //                         iconScale={0.5}
  //                         // noIcon
  //                         condensed
  //                         hideButtons
  //                         // pointerEvents={!!openDirection ? 'box-only' : 'auto'}
  //                         // onPress={!!openDirection ? () => close() : undefined}
  //                         // onSubmit={() => onComplete ? onComplete(value) : null}
  //                         // onCancel={() => onCancel ? onCancel(value) : null}
  //                         // loading={value.loading}
  //                         // onLongPress={noDrag ? undefined : item.drag}
  //                         // style={item.item.isActive ? {borderWidth: 2, borderColor: colors.trim} : null}
  //                         // onPressRight={openLeft}
  //                         // onPressLeft={openRight}
  //                         minWidth={300}
  //                       />
  //                     );
  //                   }
  //                   return (
  //                     <Value
  //                       circle
  //                       layers
  //                       ref={(ref) => {
  //                         this[`val_${value.id}`] = ref;
  //                         this.props.setValueRef &&
  //                           this.props.setValueRef(ref, `val_${value.id}`);
  //                       }}
  //                       textIcon={textIcon}
  //                       // size={size}
  //                       size={!flexExpansion ? size : 100}
  //                       // size={!isHovered ? size : 100}
  //                       scale={scale}
  //                       // scale={!flexExpansion ? scale : 1.25}
  //                       indicator={value.revisions?.length}
  //                       value={value}
  //                       // value={{...value, text: value.text + ' ' + size}}
  //                       onLongPressAdditionally={
  //                         this.props.onLongPressAdditionally
  //                       }
  //                       onLongPress={this.props.onLongPress}
  //                       // onPress={this.props.onPress}
  //                       onPress={(v) => {
  //                         if (isDragging) return null;
  //                         else {
  //                           if (this.props.onPress)
  //                             this.props.onPress(
  //                               v,
  //                               this[`val_${value.id}`],
  //                               size
  //                             );
  //                           else
  //                             RootNavigation.push("Project", {
  //                               value,
  //                               id: value.id,
  //                             });
  //                         }
  //                       }}
  //                       // maxWidth={200}
  //                       // style={styles[key]}
  //                       style={listView ? { flex: 1, padding: 0 } : null}
  //                       hideRing={listView}
  //                       progressBar={listView}
  //                       onUpdate={this.props.onUpdate}
  //                       focusIds={this.props.focusIds}
  //                       showFocusRing={this.props.showFocusRing}
  //                       coloredNotches
  //                       date={this.props.date}
  //                     />
  //                   );
  //                 }}
  //               </Draggable>
  //             )}
  //             {/*<Text>{this.state.childSizes[uKey]}</Text>*/}
  //             {listView ? (
  //               key == "parents" ? (
  //                 <View style={[styles.col]}>
  //                   {/*nextGen.map(v => this.renderGeneration(v, key, nextLevel))*/}
  //                 </View>
  //               ) : null
  //             ) : (
  //               <View style={[styles.row]}>
  //                 {allowShowMore && (
  //                   <Text
  //                     button
  //                     onPress={() => this.setState({ showMore: true })}
  //                     numberOfLines={1}
  //                     style={{ alignSelf: "center" }}
  //                   >
  //                     More
  //                   </Text>
  //                 )}
  //                 {(true || !recurOnHover || isHovered || level === 0) &&
  //                   nextGen.map((v) => {
  //                     let nextRelativeLevel = nextLevel > 0 ? 1 : -1;
  //                     let nextLevelScale =
  //                       1.0 + nextRelativeLevel * this.props.scaleFactor;
  //                     nextLevelScale = Math.min(1, nextLevelScale); // only scale down
  //                     let nextSize = Math.max(1, size * nextLevelScale);

  //                     let nextGenLengthFactor = nextGen.length;
  //                     let nextGenScaling = 0.95 ** nextGenLengthFactor;
  //                     nextSize = nextSize * nextGenScaling;

  //                     if (nextGenOnly) nextSize = 100;
  //                     // nextSize = null

  //                     return this.renderGeneration({
  //                       value: v,
  //                       key,
  //                       level: nextLevel,
  //                       parentSize: flexExpansion ? 100 : nextSize,
  //                       // flexExpansion ? 100 : this.state.childSizes[uKey]
  //                       visible: !recurOnHover || isHovered || level === 0,
  //                     });
  //                   })}
  //               </View>
  //             )}
  //           </Animated.View>
  //         );
  //       }}
  //     </Hoverable>
  //   );
  // };
}

const styles = StyleSheet.create({
  row: {
    zIndex: -1,
    flex: -1,
    // flex: 1,
    flexDirection: "row",
    alignSelf: "stretch",
    justifyContent: "space-around",
    // flexWrap: 'wrap',
    flexWrap: "nowrap",
    // paddingLeft: sizes.base,
    // padding: 2,
    // borderWidth: 2, borderColor: 'red',
    // backgroundColor: `rgba(255,255,255,0.3)`
  },
  rowScrollerWrapper: {
    // flex: 1,
    // borderWidth: 2, borderColor: 'blue',
    // alignSelf: 'stretch',
  },
  rowScroller: {
    borderWidth: 2,
    borderColor: "red",
    // zIndex: -1,
    // flex: -1,
    // flex: 1,
    // flexDirection: 'row',
    // alignSelf: 'stretch',
    // justifyContent: 'space-around',
    // flexWrap: 'wrap',
    // flexWrap: 'nowrap',
    // paddingLeft: sizes.base,
    // padding: 2,
    // borderWidth: 2,
    // borderColor: 'red',
    // backgroundColor: `rgba(255,255,255,0.3)`
  },
  col: {
    zIndex: -1,
    flex: 1,
    flexDirection: "column",
    // alignSelf: 'stretch',
    justifyContent: "flex-start",
    // alignItems: 'stretch',
    alignItems: "center",
    // flexWrap: 'nowrap',
    paddingTop: sizes.base,
    // borderColor: 'blue', borderWidth: 1,
    borderRadius: sizes.borderRadius,
    maxWidth: "100%",
  },
  colReverse: {
    flexDirection: "column-reverse",
  },
  colWrap: {
    flex: -1,
    // flex: 1,
    flexDirection: "row",
    alignSelf: "flex-start",
    flexWrap: "wrap",
    // borderBottomColor: colors.foreground,
    // borderBottomWidth: 1,
  },
  // new
  contentRow: {
    flex: 1,
    marginTop: sizes.giant,
    marginBottom: sizes.large,
    alignSelf: "stretch",
    alignItems: "stretch",
    zIndex: -1,
    alignItems: "center",
  },
  dot: {
    width: sizes.base,
    height: sizes.base,
    borderRadius: sizes.base,
    marginLeft: sizes.base,
  },
});
